import { ServiceDataFields } from './service-data-fields.enum';

export const paternityFieldSet = [
  ServiceDataFields.ParentingTestType,
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.PatientGender,
  ServiceDataFields.Relationship,
  ServiceDataFields.AdditionalParticipants,
  ServiceDataFields.FraternityInformation,
];
